import React, {useState} from 'react';
import Modal from "./Modal";

function BookItem({book}) {
    console.log(book);
    const [show, setShow] = useState(false)
    const [bookItem, setItem] = useState()
    return (
        <div className='container'>
            {
                book.map((item) => {
                    let thumbnail = item.volumeInfo.imageLinks && item.volumeInfo.imageLinks.smallThumbnail;
                    let amount = item.saleInfo.listPrice && item.saleInfo.listPrice.amount;
                    if(thumbnail!= undefined && amount != undefined){
                        return(
                            <>
                                <div className="card" onClick={() => {setShow(true); setItem(item)} }>
                                    <div className="card-image waves-effect waves-block waves-light">
                                        <img className="activator" src={thumbnail} />
                                    </div>
                                    <div className="card-content">
                                    <span className="card-title activator grey-text text-darken-4">{item.volumeInfo.title.slice(0,14)}...<i
                                        className="material-icons right">&#8377; {amount}</i></span>
                                        <p><a href="#">This is a link</a></p>
                                    </div>

                                </div>
                                <Modal show={show} item={bookItem} onClose={() => setShow(false)} />
                            </>
                        )
                    }

                })
            }
        </div>
    );
}

export default BookItem;